import React, { useState, useEffect } from 'react'
import { useCookies } from 'react-cookie'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { differenceInDays, format } from 'date-fns'

import { base64ToBlob, getDateByTimezone, getDatesByDay } from 'utils/utils'
import server from 'server/serverController2'

import Presenter from 'components/presenters/campaign/CampaignMainFooterJoinBtn'
import SocialShareModal from 'components/containers/share/SocialShareModal'
import BottomConfirmModal from 'components/presenters/modal/BottomConfirmModal'
import CenterModal from 'components/presenters/modal/CenterModal'

import greenCircleCheckIcon from 'images/icon/green_circle_check_icon-106×106.png'
import { BankAccountStateActions } from 'store/actionCreators'

//캠페인 하단
export default function CampaignMainFooterJoinBtn({
  campaignInfo,
  waitingInfo,
  socialApplyData,
  onVerticalBtnCenterModal,
  setInitVerticalBtnCenterModal,
  onClickJoinBtn,
  onShowPersonalDataUpdateModal,
  onReloadReq,
  onError,
  onShowAccoutFormModal,
}) {
  const [cookies, setCookie, removeCookie] = useCookies(['is_sol_installed'])
  const userInfo = useSelector((state) => {
    return state.userInfo
  })

  const [imgCancelable, setImgCancelable] = useState(true)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [showSocialShareModal, setShowSocialShareModal] = useState(false)
  //ShareDataState
  const [shareImg, setShareImg] = useState(null)
  const [socialUsername, setSocialUsername] = useState(null)

  //center modal state
  const [initCenterModal, setInitCenterModal] = useState(false)
  const [centerModalVisible, setCenterModalVisible] = useState(false)
  const [centerModalDataList, setCenterModalDataList] = useState({})
  const [onModalComplete, setOnModalComplete] = useState(null)
  const [onModalCancel, setOnModalCancel] = useState(null)
  //bottom confirm modal
  const [showBottomConfirmModal, setShowBottomConfirmModal] = useState(false)

  const history = useHistory()
  const currDate = getDateByTimezone('Asia/Seoul')

  //Init Center Modal State
  useEffect(() => {
    if (initCenterModal === true) {
      setCenterModalVisible(false)
      setCenterModalDataList({})
      setOnModalComplete(null)
      setOnModalCancel(null)
      setInitCenterModal(false)
    }
  }, [initCenterModal])

  //check social share image is cancelable
  useEffect(() => {
    if (campaignInfo?.no) {
      server.getRequestData(`campaigns/${campaignInfo.no}/social/share/init`, async (res) => {
        try {
          if (res.success !== 1) {
            return
          }
          const jsonData = res.data
          const socialShareInfo = jsonData['init_data']
          if (socialShareInfo?.base_img) {
            setImgCancelable(false)
          }
        } catch (err) {
          console.log(err)
        }
      })
    }
  }, [campaignInfo])

  const handleJoinReq = async () => {
    try {
      let response = await server.getRequestData('users/personal')
      if (response.success !== 1) {
        const errData = response?.error?.res_data
        throw errData
      }

      response = await server.getRequestData('users/shinhan')

      const isSolInstalled = response?.data?.shinhan_data?.is_sol_installed
      let shinhanLink = campaignInfo?.shinhan_external_link
      if (campaignInfo?.type === 'shinhan') {
        //&& is_sol_installed === false
        if (shinhanLink && isSolInstalled !== true) {
          if (userInfo.deviceType === 'iOS') {
            window.location.href = shinhanLink
          } else {
            window.open(shinhanLink, '_blank', 'noopener,noreferrer')
          }
        } else {
          response = await server.getRequestData('users/bank/account')
          if (response?.success !== 1) {
            const errData = response.error.res_data
            throw errData.detail_code
          }
          const { bank_accounts } = response.data
          if (bank_accounts[0]) {
            BankAccountStateActions.updateBankAccountState({
              bank_code: bank_accounts[0].bank_code,
              account_number: bank_accounts[0].account_number,
              account_holder_name: bank_accounts[0].account_holder_name,
            })
          }

          onShowAccoutFormModal(requestCampaignJoin)
        }
      } else if (campaignInfo?.waiting_list === true) {
        setCenterModalVisible(true)
        setCenterModalDataList({
          title: `리그램 필수`,
          description: `리그램이 필수 조건인 챌린지에요.\n리그램 하러 갈까요?`,
        })
        setOnModalComplete(() => () => {
          setInitCenterModal(true)
          setShowSocialShareModal(true)
        })
        setOnModalCancel(() => () => {
          setInitCenterModal(true)
        })
      } else {
        if (campaignInfo?.join_description) {
          setCenterModalVisible(true)
          setCenterModalDataList({ description: `${campaignInfo?.join_description}` })
          setOnModalComplete(() => () => {
            setInitCenterModal(true)
            requestCampaignJoin()
          })
          setOnModalCancel(() => () => {
            setInitCenterModal(true)
          })
        } else {
          requestCampaignJoin()
        }
      }
    } catch (err) {
      console.log('error')
      console.log(err)
      if (err?.detail_code === 'USER_PERSONAL_DATA_NOT_EXIST') {
        if (onShowPersonalDataUpdateModal) {
          onShowPersonalDataUpdateModal()
        }
      }
    }
  }

  const handleShowDeniedReason = () => {
    if (waitingInfo?.status === 'denied' && waitingInfo?.denial_reason) {
      const dataList = {
        title: waitingInfo?.denial_reason?.title,
        description: waitingInfo?.denial_reason?.description,
      }
      const btnList = []

      if (waitingInfo?.required_action === 'regram_required') {
        btnList.push({
          text: '리그램 하러가기',
          onAction: () => handleRegram(),
          wrapperStyle: { background: '#FFCF19', color: '#121212' },
        })
      } else if (waitingInfo?.required_action === 'modify_instagram_setting') {
        btnList.push({
          text: '인스타로 가기',
          onAction: () => handleOpenInstagram(),
          wrapperStyle: { background: '#FFCF19', color: '#121212' },
        })
        btnList.push({
          text: '참여승인 재요청',
          onAction: () => handleReRequestCampaignWaiting(),
          wrapperStyle: { border: `1px solid #D5D5D5`, color: '#121212' },
        })
      } else if (waitingInfo?.required_action === 'reset_apply_data') {
        btnList.push({
          text: '다시 참여하기',
          onAction: () => handleReJoinReq(),
          wrapperStyle: { background: '#FFCF19', color: '#121212' },
        })
      }
      onVerticalBtnCenterModal(true, dataList, btnList, true, true)
    }
  }

  const handleRegram = () => {
    setShowSocialShareModal(true)
    setInitVerticalBtnCenterModal(true)
  }

  const handleOpenInstagram = () => {
    window.open('https://www.instagram.com', '_blank')
  }

  const handleReRequestCampaignWaiting = () => {
    requestUpdateCampaignWaiting()
    setInitVerticalBtnCenterModal(true)
  }

  const handleReJoinReq = async () => {
    try {
      if (isSubmitting === false) {
        setIsSubmitting(true)
        const targetCampaignNo = campaignInfo.no

        const response = await server.deleteRequestData(`campaigns/${targetCampaignNo}/waitings`)
        setIsSubmitting(false)
        if (response['success'] !== 1) {
          onReloadReq()
          return
        }

        if (onReloadReq) {
          onReloadReq()
        }
        setInitVerticalBtnCenterModal(true)
      }
    } catch (err) {
      setIsSubmitting(false)
      console.log('error')
      console.log(err)
    }
  }

  const requestCampaignWaiting = async () => {
    try {
      if (isSubmitting === false) {
        setIsSubmitting(true)
        const targetCampaignNo = campaignInfo.no

        const formData = new FormData()
        const blobFile = await base64ToBlob(shareImg)

        formData.append('path', 'campaign_social_share_img/')
        formData.append('file', blobFile)
        const uploadFile = await server.postRequestData('file', formData)
        if (uploadFile['success'] !== 1) {
          return
        }
        const fileName = uploadFile['data']['upload_results'][0]['file_name']

        const body = {}
        body['social_username'] = socialUsername
        body['social_type'] = 'instagram'
        body['shared_img'] = fileName

        server.postRequestData(`campaigns/${targetCampaignNo}/waitings`, body, (res) => {
          try {
            setIsSubmitting(false)
            if (res.success !== 1) {
              //err 이미 req 존재합니다.
              onReloadReq()
              return
            }

            if (onReloadReq) {
              onReloadReq()
            }
          } catch (err) {
            setIsSubmitting(false)
            console.log(err)
          }
        })
      }
    } catch (err) {
      console.log('error')
      console.log(err)
    }
  }

  const requestUpdateCampaignWaiting = async () => {
    try {
      if (isSubmitting === false) {
        setIsSubmitting(true)
        const targetCampaignNo = campaignInfo.no
        const body = {}
        if (waitingInfo?.required_action !== 'modify_instagram_setting') {
          const formData = new FormData()
          const blobFile = await base64ToBlob(shareImg)

          formData.append('path', 'campaign_social_share_img/')
          formData.append('file', blobFile)
          const uploadFile = await server.postRequestData('file', formData)
          if (uploadFile['success'] !== 1) {
            return
          }
          const fileName = uploadFile['data']['upload_results'][0]['file_name']

          body['shared_img'] = fileName
          body['social_username'] = socialUsername
        }

        if (waitingInfo?.status === 'denied') {
          body['status'] = 'pending'
          body['denial_reason'] = null
          body['required_action'] = null
        }

        const response = await server.putRequestData(`campaigns/${targetCampaignNo}/waitings`, body)
        setIsSubmitting(false)
        if (response['success'] !== 1) {
          onReloadReq()
          return
        }
        if (onReloadReq) {
          onReloadReq()
        }
      }
    } catch (err) {
      setIsSubmitting(false)
      console.log('error')
      console.log(err)
    }
  }

  const requestCampaignJoin = () => {
    if (isSubmitting === false) {
      setIsSubmitting(true)
      const targetCampaignNo = campaignInfo.no
      server.postRequestData(`campaigns/${targetCampaignNo}/members`, {}, (res) => {
        try {
          setIsSubmitting(false)
          if (res.success === 1) {
            onReloadReq()
            removeCookie('is_sol_installed', { path: '/' })

            const startDate =
              campaignInfo?.start_date &&
              format(new Date(getDateByTimezone('Asia/Seoul', campaignInfo?.start_date)), 'M/d')
            const description = startDate
              ? `참여가 완료되었어요\n챌린지는 ${startDate}에 시작돼요!`
              : `참여가 완료되었어요\n오늘부터 인증해 주세요!`
            const dataList = {
              image: greenCircleCheckIcon,
              title: '참여 완료',
              description: description,
            }
            const btnList = [
              {
                text: '확인',
                onAction: () => setInitVerticalBtnCenterModal(true),
                wrapperStyle: { background: '#FFCF19', color: '#121212' },
              },
            ]
            onVerticalBtnCenterModal(true, dataList, btnList, false, false)
          } else {
            let errData = res['error']['res_data']

            if (errData['detail_code'] === 'USER_PERSONAL_DATA_NOT_EXIST') {
              if (onShowPersonalDataUpdateModal) {
                onShowPersonalDataUpdateModal()
              }
            } else {
              if (onError) {
                onError(errData)
              }
            }
          }
        } catch (err) {
          setIsSubmitting(false)
          console.log(err)
        }
      })
    }
  }

  let btnType = null
  let remainedDay = null
  if (campaignInfo) {
    const startDate = campaignInfo?.start_date
    const endDate = campaignInfo?.end_date
    const isMember = campaignInfo?.is_member
    const taskDay = campaignInfo?.day

    if (process.env.REACT_APP_ENV !== 'dev' && userInfo?.isMobile && !userInfo?.isApp) {
      btnType = 'redirectAppStore'
    } else if (userInfo['isLogin'] !== true) {
      btnType = 'loginReq'
    } else if (
      (isMember !== true &&
        campaignInfo?.max_capacity &&
        campaignInfo.current_capacity >= campaignInfo.max_capacity) ||
      currDate > endDate ||
      (isMember !== true && startDate && currDate > startDate)
    ) {
      //챌린지 마감 -> 종료일이 지났거나 or 비 참여자중 상시모집이 아니고 시작일이 지남
      btnType = 'expired'
    } else if (isMember === true) {
      const taskDateList = startDate
        ? getDatesByDay(startDate, endDate, taskDay)
        : getDatesByDay(currDate, endDate, taskDay)

      if (startDate === null || currDate >= startDate) {
        if (taskDateList.includes(currDate)) {
          btnType = 'redirectTaskListBtn' //인증일
        } else {
          btnType = 'disabledTaskListBtn' //인증일 아닐 경우
        }
      } //일반 캠페인 맴버이고 시작일 전일 경우
      else {
        remainedDay = differenceInDays(new Date(startDate), new Date(currDate))
        btnType = 'remainingDay'
      }
    } else {
      //아직 맴버가 아니고 시작일 전일 경우
      if (waitingInfo) {
        if (waitingInfo.status === 'denied') {
          btnType = 'checkDeniedReason'
        } else {
          btnType = 'checkJoinStatus'
        }
      } else {
        btnType = 'joinReqBtn'
      }
    }
  }

  return (
    <>
      <Presenter
        type={btnType}
        remainingDay={remainedDay}
        campaignNo={campaignInfo?.no ? campaignInfo.no : null}
        onJoinCampaign={handleJoinReq}
        onShowJoinStatus={() => {
          setShowSocialShareModal(true)
        }}
        onShowDeniedReasonBtn={handleShowDeniedReason}
      />

      <SocialShareModal
        visible={showSocialShareModal}
        campaignNo={campaignInfo?.no ? campaignInfo.no : null}
        shareImg={socialApplyData?.shared_img}
        onClose={(shareTriggered) => {
          setShowSocialShareModal(false)
        }}
        isImgCancelable={imgCancelable}
        onShare={(shareImg, socialUsername) => {
          setSocialUsername(socialUsername)
          setShareImg(shareImg)
          setShowBottomConfirmModal(true)
        }}
      />
      <CenterModal
        modalVisible={centerModalVisible}
        setModalVisible={setCenterModalVisible}
        dataList={centerModalDataList}
        onCancel={onModalCancel}
        onComplete={onModalComplete}
      />
      <BottomConfirmModal
        visible={showBottomConfirmModal}
        title={'리그램 검토중'}
        description={`리그램 여부를 확인 후,\n참여 승인을 알림으로 알려드릴게요!`}
        onCancel={() => {
          setShowBottomConfirmModal(false)
        }}
        onComplete={() => {
          setShowBottomConfirmModal(false)
          setShowSocialShareModal(false)
          if (waitingInfo?.status === 'pending' || waitingInfo?.status === 'denied') {
            requestUpdateCampaignWaiting()
          } else {
            requestCampaignWaiting()
          }
        }}
      />
    </>
  )
}
